/**
 * Phase 45 Plan 45-05 — DueLabel for portfolio rows.
 *
 * Visual: tabular-nums label with semantic tone:
 *   - dueDays < 0 → "{N}d overdue" (text-red-600)
 *   - dueDays < 7 → "in {N}d" (text-amber-700)
 *   - else        → "in {N}d" (text-ms-text-muted)
 *
 * Source: UI-SPEC §Surface 1 Column 7 + Copy lock "Due label templates".
 */
export interface DueLabelProps {
  dueDays: number | null;
}

export function DueLabel({ dueDays }: DueLabelProps) {
  if (dueDays === null || dueDays === undefined) {
    return <span className="text-[11px] text-ms-text-muted">—</span>;
  }
  if (dueDays < 0) {
    const overdue = Math.abs(dueDays);
    return (
      <span className="text-[11px] tabular-nums font-medium text-red-600">
        {overdue}d overdue
      </span>
    );
  }
  if (dueDays < 7) {
    return (
      <span className="text-[11px] tabular-nums font-medium text-amber-700">
        in {dueDays}d
      </span>
    );
  }
  return (
    <span className="text-[11px] tabular-nums text-ms-text-muted">in {dueDays}d</span>
  );
}
